import { required, requiredIf, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      message: {
        required: helpers.withMessage(i18n.global.t('Please enter a description.'), required)
      },
      amount: {
        required: helpers.withMessage(i18n.global.t('Please enter an amount.'), required),
        minValue: helpers.withMessage(i18n.global.t('Amount must be 0 or more.'), minValue(0))
      },
      expense_date: {
        required: helpers.withMessage(i18n.global.t('Please select a date.'), required)
      },
      expense_category_id: {
        required: helpers.withMessage(i18n.global.t('Please select a category.'), required)
      },
      // สาขาบังคับเฉพาะตอนมีใบกำกับภาษี — อัตรา VAT เก็บอยู่ที่สาขาเท่านั้น ไม่รู้สาขา = คำนวณไม่ได้
      // (ค่าใช้จ่ายทั่วไปยังไม่ระบุสาขาได้เหมือนเดิม — vat-compliance.md ตัดสินใจ A2)
      branch_id: {
        required: helpers.withMessage(
          i18n.global.t('Please select a branch for an expense with a tax invoice.'),
          requiredIf(() => formState.has_tax_invoice)
        )
      },
      tax_invoice_no: {
        required: helpers.withMessage(
          i18n.global.t('Please enter the tax invoice number.'),
          requiredIf(() => formState.has_tax_invoice)
        )
      },
      tax_invoice_date: {
        required: helpers.withMessage(
          i18n.global.t('Please select the tax invoice date.'),
          requiredIf(() => formState.has_tax_invoice)
        )
      }
    }
  }
};
